/** Time range tuple used by MSE SourceBuffer and HTMLMediaElement buffered properties. */
export type HlsTimelineTimeRange = {
  start: number;
  end: number;
};

/** Snapshot row for a media or SourceBuffer buffered range track. */
export type HlsTimelineBufferRow = {
  rowType: 'buffer';
  id: string;
  bufferKind: 'media' | 'video' | 'audio' | 'audiovideo';
  trackId?: string;
  ranges: HlsTimelineTimeRange[];
  rangeCount: number;
  totalDuration: number;
  forwardBuffer: number | null;
  backBuffer: number | null;
  bufferStart: number | null;
  bufferEnd: number | null;
  /** Estimated bytes currently held in this buffer (demuxed MSE data when available). */
  bufferedBytes: number;
};

/** Snapshot row for an HLS playlist track (main, audio, or subtitles). */
export type HlsTimelinePlaylistRow = {
  rowType: 'playlist';
  id: string;
  playlistKind: 'level' | 'audioTrack' | 'subtitleTrack';
  label: string;
  url?: string;
  levelIndex?: number;
  fragmentCount: number;
  partCount: number;
  loadedFragments: number;
  loadedBytes: number;
  totalBytes: number;
  /** Estimated bytes from this playlist currently held in the media buffer. */
  bufferedBytes: number;
  playlistDuration: number | null;
  targetDuration: number | null;
  live: boolean | null;
  isActive: boolean;
};

/** Full tabular snapshot exposed to the stats table component. */
export type HlsTimelineStats = {
  bufferRows: HlsTimelineBufferRow[];
  playlistRows: HlsTimelinePlaylistRow[];
  currentTime: number | null;
  maxBufferLength: number | null;
  forwardBufferInfo: { len: number; start: number; end: number } | null;
  updatedAt: number;
};

export const EMPTY_HLS_TIMELINE_STATS: HlsTimelineStats = {
  bufferRows: [],
  playlistRows: [],
  currentTime: null,
  maxBufferLength: null,
  forwardBufferInfo: null,
  updatedAt: 0,
};
